module.exports = __webpack_public_path__ + "img/fitbit.c0c22086.png";